import DateTile from './DateTile';

export default DateTile;
